import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

// NOTE: intentionally simple. We route password-reset requests through
// support@pocltc.org rather than running an automated email service, since
// resets are rare (~1% of users/year) and this avoids the monthly cost of
// SendGrid/Resend/etc. Admin resets manually from /admin/users.
export default function ForgotPasswordPage() {
  const mailto = 'mailto:support@pocltc.org?subject=' +
    encodeURIComponent('Password reset request') +
    '&body=' +
    encodeURIComponent(
      "Hi,\n\nI'd like to reset the password on my Piece of Cake LTC account.\n\n" +
      "My account email: \n\nThanks!"
    );

  return (
    <div className="min-h-screen"><Navbar />
      <main className="max-w-[560px] mx-auto px-6 lg:px-8 pt-12 pb-16">
        <Link to="/login" className="inline-flex items-center gap-1 text-[12.5px] text-[#7A857F] hover:text-[#1A2622]" data-testid="forgot-back-login">
          <ArrowLeft size={13}/> Back to sign in
        </Link>
        <h1 className="mt-3 font-display text-3xl text-[#1A2622]">Reset your password</h1>
        <p className="mt-3 text-[13.5px] text-[#3A4A44] leading-relaxed">
          Send us a quick email and we&apos;ll reset your password within one business day. Use the button below and it will pre-fill everything — just add your account email and hit send.
        </p>
        <a href={mailto}
           className="mt-6 inline-flex items-center gap-2 h-11 px-5 rounded-md bg-[#1A2622] text-[#FBF6EC] text-[13px] font-medium hover:bg-[#2D5F4F]"
           data-testid="forgot-mailto-btn">
          <Mail size={14}/> Email support@pocltc.org
        </a>
        <div className="mt-8 text-[12px] text-[#7A857F] leading-relaxed">
          <strong>Tip:</strong> if you originally signed in with Google, just click <Link to="/login" className="text-[#34538F] hover:underline">Sign in</Link> and use the same Google account — no password needed.
        </div>
      </main>
      <Footer />
    </div>
  );
}
